import request from '@/utils/request'

// 查询变量管理列表
export function listVar(data) {
  return request({
      url: '/server/var/list',
      method: 'get',
      params: data
  })
}

// 新增变量管理
export function addVar(data) {
  return request({
      url: '/server/var/add',
      method: 'post',
      data: data
  });
}
// 修改变量管理
export function editVar(data) {
  return request({
      url: '/server/var/edit',
      method: 'post',
      data: data
  });
}
// 删除变量管理
export function deleteVar(data) {
  return request({
      url: '/server/var/delete/'+data.varId,
      method: 'post',
      data: data
  });
}

// 获取变量管理详细信息
export function getVar(data) {
  return request({
      url: '/server/var/getInfo/'+data.varId,
      method: 'get',
      params: data
  })
}